import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KlLoaderSize } from './kl-loader.models';

/** Logo + label loader; `label` is an i18n key, the host owns overlay, position and min-height. */
@Component({
  selector: 'kl-loader',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './kl-loader.html',
  styleUrl: './kl-loader.scss',
  host: {
    role: 'status',
    'aria-live': 'polite',
    '[class.kl-loader--sm]': "size() === 'sm'",
    '[class.kl-loader--md]': "size() === 'md'",
    '[class.kl-loader--lg]': "size() === 'lg'",
  },
})
export class KlLoader {
  readonly label = input('loading');
  readonly size = input<KlLoaderSize>('md');
}
